"use client";

import { FormEvent, useState } from "react";
import { CheckCircle2 } from "lucide-react";

export function ContactForm() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");

    const form = event.currentTarget;
    const response = await fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Object.fromEntries(new FormData(form))),
    }).catch(() => null);

    setSubmitting(false);
    if (!response?.ok) {
      setError("提交失败，请稍后重试，或通过电话、邮箱与我们联系。");
      return;
    }

    setSubmitted(true);
  };

  if (submitted)
    return (
      <div className="form-success">
        <div>
          <CheckCircle2 />
          <h2>您的诊断申请已收到</h2>
          <p>增长顾问将在 24 小时内与您联系，确认沟通时间与需要准备的资料。</p>
          <button
            className="button button-dark"
            type="button"
            onClick={() => setSubmitted(false)}
          >
            提交另一份申请
          </button>
        </div>
      </div>
    );

  return (
    <form className="contact-form" onSubmit={onSubmit}>
      <div className="form-section-heading">
        <strong>基本信息</strong>
        <span>便于顾问与您取得联系</span>
      </div>
      <div className="field full">
        <label htmlFor="company">企业名称 *</label>
        <input
          id="company"
          name="company"
          autoComplete="organization"
          placeholder="请填写企业或公司全称"
          required
        />
      </div>
      <div className="field">
        <label htmlFor="name">联系人 *</label>
        <input
          id="name"
          name="name"
          autoComplete="name"
          placeholder="请输入联系人姓名"
          required
        />
      </div>
      <div className="field">
        <label htmlFor="contact">联系方式 *</label>
        <input
          id="contact"
          name="contact"
          inputMode="email"
          placeholder="手机号或工作邮箱"
          required
        />
      </div>
      <div className="form-section-heading">
        <strong>业务情况</strong>
        <span>帮助我们提前判断沟通重点</span>
      </div>
      <div className="field">
        <label htmlFor="industry">所属行业 *</label>
        <select id="industry" name="industry" defaultValue="" required>
          <option value="" disabled>
            请选择所属行业
          </option>
          <option>制造与外贸</option>
          <option>消费与行业品牌</option>
          <option>创新、SaaS 与 AI</option>
          <option>专业服务</option>
          <option>其他</option>
        </select>
      </div>
      <div className="field">
        <label htmlFor="market">目标市场 *</label>
        <select id="market" name="market" defaultValue="" required>
          <option value="" disabled>
            请选择目标市场
          </option>
          <option>中国市场</option>
          <option>全球市场</option>
          <option>中国与全球</option>
        </select>
      </div>
      <div className="field">
        <label htmlFor="website">现有官网</label>
        <input id="website" name="website" placeholder="https://" type="url" />
      </div>
      <div className="field">
        <label htmlFor="service">希望沟通的服务</label>
        <select id="service" name="service" defaultValue="">
          <option value="">暂不确定，希望先诊断</option>
          <option>品牌与产品表达</option>
          <option>官网与独立站</option>
          <option>内容增长</option>
          <option>SEO / GEO</option>
          <option>市场增长</option>
          <option>线索与持续运营</option>
        </select>
      </div>
      <div className="field full">
        <label htmlFor="challenge">当前主要问题 *</label>
        <textarea
          id="challenge"
          name="challenge"
          placeholder="例如：品牌表达不清、官网缺少询盘、海外客户难以获取等"
          required
        />
      </div>
      <label className="check-row">
        <input type="checkbox" required />
        <span>
          我已阅读并同意<a href="/privacy">隐私政策</a>，同意增长深度就本次咨询与我联系。
        </span>
      </label>
      <button
        className="button button-dark form-submit"
        type="submit"
        disabled={submitting}
      >
        {submitting ? "正在提交..." : "提交增长诊断申请"}
      </button>
      {error && (
        <p className="form-error" role="alert">
          {error}
        </p>
      )}
      <p className="form-note">
        提交后，我们将在 24 小时内与您联系确认诊断安排。
      </p>
    </form>
  );
}
